<template>
<div>
    <v-row>
        <!--end of title-->
        <v-col cols="4">
            <div class="mb-3 font-weight-bold">Удостоверение личности</div>
            <ol v-if="formData && formData.document">
                <li>
                    <b>Вид документа:</b> Паспорт
                </li>
                <li>
                    <b>Серия документа:</b>
                    {{formData.document.series | emptyMessage}}
                </li>
                <li>
                    <b>Номер документа:</b>
                    {{formData.document.number | emptyMessage}}
                </li>
                <li>
                    <b>Кем выдан:</b>
                    {{formData.document.issuer | emptyMessage}}
                </li>
                <li>
                    <b>Дата выдачи:</b>
                    {{formData.document.issueDate | humanReadableDate}}
                </li>
                <li>
                    <b>Код подразделения:</b>
                    {{formData.document.unitCode | emptyMessage}}
                </li>
                <li>
                    <b>Дата рождения:</b>
                    {{formData.document.birthDate | humanReadableDate}}
                </li>
                <li>
                    <b>Место рождения:</b>
                    {{formData.document.birthPlace | emptyMessage}}
                </li>
                <li>
                    <b>ИНН:</b>
                    {{formData.document.inn | emptyMessage}}
                </li>
                <li>
                    <b>Телефон для связи:</b>
                    {{formData.document.phone | emptyMessage}}
                </li>
            </ol>
        </v-col>

        <v-col cols="4">
            <div class="mb-3 font-weight-bold">Адрес регистрации заявителя</div>
            <ol v-if="formData.addresses">
                <li>
                    <b>Индекс:</b>
                     {{registrationsAddress.index | emptyMessage}}
                </li>
                <li>
                    <b>Субъект РФ:</b> Республика Татарстан
                </li>
                <li>
                    <b>Район:</b>
                    {{registrationsAddress.district | emptyMessage}}
                </li>
                <li>
                    <b>Населенный пункт/Город:</b>
                    {{registrationsAddress.city | emptyMessage}}
                </li>
                <li>
                    <b>Улица:</b>
                    {{registrationsAddress.street | emptyMessage}}
                </li>
                <li>
                    <b>Дом:</b>
                    {{registrationsAddress.house | emptyMessage}}
                </li>
                <li>
                    <b>Квартира:</b>
                    {{registrationsAddress.flat | emptyMessage}}
                </li>
            </ol>
        </v-col>
        <v-col cols="4">
            <div class="mb-3 font-weight-bold">Адрес доставки квитанции</div>

            <ol v-if="formData.addresses">
                <li>
                    <b>Индекс:</b>
                    {{deliveryAddress.index | emptyMessage}}
                </li>
                <li>
                    <b>Субъект РФ:</b> Республика Татарстан
                </li>
                <li>
                    <b>Район:</b>
                    {{deliveryAddress.district | emptyMessage}}
                </li>
                <li>
                    <b>Населенный пункт/Город:</b>
                    {{deliveryAddress.city | emptyMessage}}
                </li>
                <li>
                    <b>Улица:</b>
                    {{deliveryAddress.street | emptyMessage}}
                </li>
                <li>
                    <b>Дом:</b>
                    {{deliveryAddress.house | emptyMessage}}
                </li>
                <li>
                    <b>Квартира:</b>
                    {{deliveryAddress.flat | emptyMessage}}
                </li>
            </ol>

        </v-col>
    </v-row>

    <v-row>
        <v-col col="12">
            <v-divider></v-divider>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12">
            <div class="mb-3 font-weight-bold">Информация об объекте</div>
            <ol v-if="formData.resName">
                <li>
                    <b>Субъект РФ:</b> Республика Татарстан
                </li>
                <li>
                    <b>Наименование РЭС:</b>
                    {{formData.resName | emptyMessage}}
                </li>
                <li>
                    <b>Разрешенная мощность:</b>
                    {{formData.permittedPower | emptyMessage}}
                </li>
                <li>
                    <b>Кадастровый номер:</b>
                    {{formData.cadastralNumber | emptyMessage}}
                </li>
                <li>
                    <b>Общая площадь домовладения:</b>
                    {{formData.totalArea | emptyMessage}}
                </li>
                <li>
                    <b>Количество этажей в доме:</b>
                    {{formData.floor | emptyMessage}}
                </li>
                <li>
                    <b>Количество комнат домовладения:</b>
                    {{formData.numberRooms | emptyMessage}}
                </li>
                <li>
                    <b>Количество проживающих жильцов:</b>
                    {{formData.numberInhabitants | emptyMessage}}
                </li>
            </ol>
        </v-col>
    </v-row>
</div>
</template>

<script>
export default {
    props: ["income"],
    data: () => ({
        // DATA
        formData: {},
        // FORM SETTINGS
        dataIsValid: true // Важное поле для работы визарда
    }),
    computed: {
        registrationsAddress() {
       //     console.log('registrationsAddress', this.formData);
            return this.formData.addresses.find(
                item => String(item.addressType) === "802740000"
            );
        },
        deliveryAddress() {

            // console.log('da')
            // console.log(this.formData)

            if (this.formData.isEqualRegAddress) {
                return this.registrationsAddress || {}
            } else {
                return this.formData.addresses.find(
                    item => String(item.addressType) === "802740001"
                ) || {};
            }

        }
    },
    methods: {
        transferData() {
            // DATA
            this.$emit("transfer", null);
        }
    },
    created() {
        this.transferData();
        // console.log("asd",this.income)
        this.formData = this.income;
    },
    filters: {
        emptyMessage: val => (val ? val : "Не указано"),
        humanReadableDate: val => {
            return val ? new Date(val).toLocaleString('ru', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            }) : 'Не указано'
        }
    },
    watch: {
        income: {
            immediate: true,
            handler: function (value) {
                this.formData = value;
            }
        }
    }
};
</script>
